.divider {
    margin-left: -20px;
    margin-right: -20px;

    margin-bottom: 10px;
}